import Component_2DGUI_cdc6892e4dce09880f80a95622133025 from "../../../../content/examples/gui/2d-gui/2DGUI";
import Devtool_2DGUI_cdc6892e4dce09880f80a95622133025 from "!!@devtool/loader!../../../../content/examples/gui/2d-gui/2DGUI";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_2DGUI_cdc6892e4dce09880f80a95622133025,
  Devtool_2DGUI_cdc6892e4dce09880f80a95622133025,
  DevTool,
  React
};